export default "__VITE_ASSET__CMfImfBr__"